/** Painel de vencimentos — integração com a API. Só leitura. */

import apiClient from './apiClient';
import type { Horizonte, PainelDeVencimentos } from '../types/vencimento';

export * from '../types/vencimento';

export const vencimentoService = {
  async painel(filtro: { dias?: Horizonte; tipos?: string[] } = {}): Promise<PainelDeVencimentos> {
    const params = new URLSearchParams();
    if (filtro.dias !== undefined) params.set('dias', String(filtro.dias));
    if (filtro.tipos && filtro.tipos.length > 0) params.set('tipos', filtro.tipos.join(','));
    const query = params.toString();

    const { data } = await apiClient.get<PainelDeVencimentos>(
      `/vencimentos${query ? `?${query}` : ''}`
    );
    if (!data) throw new Error('Resposta vazia do servidor ao montar o painel de vencimentos');
    return data;
  },
};

export default vencimentoService;
